module.exports = __webpack_public_path__ + "media/src/application/media/logo-md-9aa32d4c88f4f1a408be977fc55cc00c.svg";